module.exports = __webpack_public_path__ + "img/serviceBanner.28fe7bcd.png";